import  styles from "./ModalProcessAlert.module.scss";
import { useState, useRef, useEffect } from "react";
import MainAppGenericModal from "components/MainApp/atoms/Modals/GenericModal";
import ModalGuardProcessingInfo from "components/MainApp/organisms/Modals/ModalGuardProcessingInfo/ModalGuardProcessingInfo";
import backArrow from "assets/images/back-arrow-icon.svg";
import backArrowLarge from "assets/images/back-arrow.svg";
import heistIcon from "assets/images/heist-icon.svg";
import triedHeistIcon from "assets/images/tried-heist-icon.svg";
import falseAlarmIcon from "assets/images/false-alarm-icon.svg";
import notProcessIcon from "assets/images/not-process-icon.svg";
import Loader from "components/MainApp/atoms/Loader";
import { GuardStatusService } from "services/GuardStatusService";
import { EventRepository } from "helpers/EventRepository";
import useRequest from "hooks/useRequest";
import useWindowSize from "hooks/useWindowSize";
import { useStore } from "store/context";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const ModalProcessAlert = ({
  isOpen,
  alert,
  handleBack,
  reloadAlerts,
  handleClose
}) => {
  const [{ alertList }, dispatch] = useStore();
  const { isMobile } = useWindowSize();
  const [optionSelected, setOptionSelected] = useState(null);
  const [comment, setComment] = useState("");
  const inputCommentRef = useRef(null);
  const [showModalGuardProcessingInfo, setShowModalGuardProcessingInfo] = useState(false);
  const [hideContent, setHideContent] = useState(false);

  const proccessAlarmOptions = [
    { id: "THEFT", icon: heistIcon, text: i18n.t("theft") },
    { id: "ATTEMPTED_THEFT", icon: triedHeistIcon, text: i18n.t("attempted.theft") },
    { id: "FALSE_ALARM", icon: falseAlarmIcon, text: i18n.t("false.alarm") },
    { id: "NOT_PROCESS", icon: notProcessIcon, text: i18n.t("not.process.now") }
  ];

  const handleSelected = option => {
    optionSelected?.id === option.id
      ? setOptionSelected(null)
      : setOptionSelected(option);
  };

  const handleCommentFocus = () => {
    inputCommentRef?.current.classList.add("comment-focused");
  };

  const handleCommentBlur = () => {
    inputCommentRef?.current.classList.remove("comment-focused");
  };

  const handleCommentChange = e => {
    setComment(e.target.value);
  };

  const handleCancel = () => {
    handleBack();
    setOptionSelected(null);
  };

  const { loading, beforeSubmit, afterSubmit, dealWithError } = useRequest();

  const updateGuardStatus = ({ id, data, isFromArray = false, isLast }) => {
    GuardStatusService.updateGuardStatus(id, data)
      .then(() => {
        if (!isFromArray) {
          dispatch({
            type: "setAlertList",
            payload: alertList.filter(a => a !== id)
          });
        }

        if (isFromArray && isLast) {
          afterSubmit();
          EventRepository.notificationSend({
          label: i18n.t(optionSelected.id === "THEFT" ? "alert.processed.successfully.theft" : "alerts.processed.successfully"),
            type: "success"
          });
          return;
        }

        afterSubmit();
        EventRepository.notificationSend({
          label: i18n.t(optionSelected.id === "THEFT" ? "alert.processed.successfully.theft" : "alert.processed.successfully"),
          type: "success"
        });
      })
      .catch(error => {
        afterSubmit();
        dealWithError(error, "generic.error", (message, errors) => {
          analizeErrors(message, errors);
        });
      })
      .finally(() => {
        setShowModalGuardProcessingInfo(false);
        if (isFromArray && !isLast) return;

        const currentPage = 1;
        reloadAlerts({ page: currentPage });
        handleClose();
      });
  };

  const handleSubmit = () => {

    if (!optionSelected) return;

    if (optionSelected.id === "THEFT") {
      setShowModalGuardProcessingInfo(true);
      setHideContent(true);
    }

    beforeSubmit();
    const data = {
      comments: comment || i18n.t("no.comment"),
      status: optionSelected.id
    };

    if (Array.isArray(alert)) {
      alert.forEach((item, idx) => {
        const isLast = alert.length - 1 === idx;
        updateGuardStatus({ id: item.id, data, isFromArray: true, isLast });
      });

      dispatch({
        type: "setAlertList",
        payload: alertList.filter(
          alertId => !alert.some(alertItem => alertItem.id === alertId)
        )
      });

      handleClose();
      return;
    }

    updateGuardStatus({ id: alert.id, data });
  };

  const analizeErrors = (message, errors = {}) => {
    if (Object.keys(errors).length === 0) {
      EventRepository.notificationSend({
        label: message,
        type: "error"
      });
    }
  };

  useEffect(() => {
    const guardItemDetailDiv = document.querySelector(".guard-item-detail");

    if (!guardItemDetailDiv) return;

    if (loading && isMobile) {
      guardItemDetailDiv.classList.add("height-max-viewport");
    } else {
      guardItemDetailDiv.classList.remove("height-max-viewport");
    }
  }, [loading]);

  const contentPopUp = (
    <section className={styles["modal-process-alert"]}>
      <header>
        <img
          src={isMobile ? backArrowLarge : backArrow}
          alt="volver"
          onClick={handleBack}
        />
        <h4>{i18n.t("process.alarm")}</h4>
      </header>
      <div className={styles["modal-process-alert__content"]}>
        <p>{i18n.t("choose.option.process.alarm")}</p>
        <div className={styles["modal-process-alert__options"]}>
          {proccessAlarmOptions.map((option, idx) => (
            <button
              key={idx}
              className={`${optionSelected?.id === option.id &&
                styles[`option-${option.id}-active`]}
                                ${styles["modal-process-alert__options--button"]}`}
              onClick={() => handleSelected(option)}
            >
              <picture>
                <img src={option.icon} />
              </picture>
              <h3>{option.text}</h3>
            </button>
          ))}
        </div>
        <div className={styles["modal-process-alert__comment"]} ref={inputCommentRef}>
          <span>{capitalize(i18n.t("description"))}</span>
          <textarea
            placeholder={i18n.t("enter.comment")}
            onFocus={handleCommentFocus}
            onBlur={handleCommentBlur}
            onChange={handleCommentChange}
          />
        </div>
      </div>
      <footer>
        <button onClick={handleCancel}>{i18n.t("cancel")}</button>
        <button disabled={!optionSelected} onClick={handleSubmit}>
          {i18n.t("confirm")}
        </button>
      </footer>
    </section>
  );

  return (
    <>
      <MainAppGenericModal
        open={isOpen}
        content={!hideContent ? contentPopUp : null}
        handleClose={handleClose}
        classContainer={styles["modal-process-alert-container"]}
        classModalContainer={styles["modal-process-alert-modal-container"]}
      />

      {!showModalGuardProcessingInfo && loading && <Loader />}

      <ModalGuardProcessingInfo open={showModalGuardProcessingInfo} />
    </>
  );
};

export default ModalProcessAlert;
